module.exports = __webpack_public_path__ + "static/img/i1.187eee3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/i1.png
// module id = 6Hd0
// module chunks = 0